import makeStyles from '@mui/styles/makeStyles';

const formPanelStyles = makeStyles((theme) => ({
    container: {
        padding: '1rem',
    },
}));

export default formPanelStyles;
